import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type ProjectManagerService from 'editor/services/project-manager';

export default class RestrictedSongsFolderIndexRoute extends Route {
  @service declare projectManager: ProjectManagerService;
  @service declare router: RouterService;

  beforeModel() {
    const folder =
      this.projectManager.currentFolder ?? this.projectManager.songFolders[0];
    if (folder) {
      const song = this.projectManager.findSong(folder);
      if (folder && song) {
        this.router.transitionTo(
          'restricted.songs.folder.song',
          folder.path,
          song.path,
        );
      }
    }
  }
}
